/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateOrderBankAccountSchemaResponse } from '../models/CreateOrderBankAccountSchemaResponse';
import type { CreateOrderPaymentGatewaySchemaResponse } from '../models/CreateOrderPaymentGatewaySchemaResponse';
import type { CreateOrderSchema } from '../models/CreateOrderSchema';
import type { OrderPaymentSchema } from '../models/OrderPaymentSchema';
import type { OrderSchema } from '../models/OrderSchema';
import type { OrderSummarySchema } from '../models/OrderSummarySchema';
import type { PagedOrderSchema } from '../models/PagedOrderSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrdersApi {
    /**
     * Create Order Bank Account
     * Create order and bank transfer info. <br>Required Permission: 'create_order'
     * @returns CreateOrderBankAccountSchemaResponse Created
     * @throws ApiError
     */
    public static ordersCreateOrderBankAccountPost({
        requestBody,
    }: {
        requestBody: CreateOrderSchema,
    }): CancelablePromise<CreateOrderBankAccountSchemaResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/orders/bank-account/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Create Order Payment Gateway
     * Create order payment gateway info. <br>Required Permission: 'create_order'<br>Required Company Permission: 'allow_subscription_card_payment'
     * @returns CreateOrderPaymentGatewaySchemaResponse Created
     * @throws ApiError
     */
    public static ordersCreateOrderPaymentGatewayPost({
        requestBody,
    }: {
        requestBody: CreateOrderSchema,
    }): CancelablePromise<CreateOrderPaymentGatewaySchemaResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/orders/payment-gateway/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Create Webpay Payment Link
     * Pay order. <br>Required permission: pay_order
     * @returns OrderPaymentSchema OK
     * @throws ApiError
     */
    public static ordersCreateWebpayPaymentLinkPost({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<OrderPaymentSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/orders/{order_id}/payment-link/',
            path: {
                'order_id': orderId,
            },
        });
    }
    /**
     * Get Company Order
     * Get company order by order id. <br>Required permissions: list_my_company_orders
     * @returns OrderSchema OK
     * @throws ApiError
     */
    public static ordersGetCompanyOrderGet({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<OrderSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/orders/{order_id}/',
            path: {
                'order_id': orderId,
            },
        });
    }
    /**
     * Get Company Order By Webpay
     * Get company order. <br>Required permissions: list_my_company_orders
     * @returns OrderSchema OK
     * @throws ApiError
     */
    public static ordersGetCompanyOrderByWebpayGet({
        paymentId,
    }: {
        paymentId: number,
    }): CancelablePromise<OrderSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/orders/{payment_id}/',
            path: {
                'payment_id': paymentId,
            },
        });
    }
    /**
     * Get Company Orders
     * List company orders. <br>Required permissions: list_my_company_orders
     * @returns PagedOrderSchema OK
     * @throws ApiError
     */
    public static ordersGetCompanyOrdersGet({
        limit = 100,
        offset,
    }: {
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedOrderSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/orders/',
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get Order Summary
     * Order summary preview for a package. Pass <code>calculate_from</code> (e.g. the current subscription's end date + 1 day) to compute the price as of that date — drops the current subscription's proportional credit so the full next-billing amount is shown. <br>Required Permission: 'create_order'
     * @returns OrderSummarySchema OK
     * @throws ApiError
     */
    public static ordersGetOrderSummaryGet({
        packageId,
        paymentModel,
        calculateFrom,
    }: {
        packageId: string,
        paymentModel: 'MONTHLY' | 'YEARLY',
        calculateFrom?: (string | null),
    }): CancelablePromise<OrderSummarySchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/orders/summary/{package_id}/',
            path: {
                'package_id': packageId,
            },
            query: {
                'payment_model': paymentModel,
                'calculate_from': calculateFrom,
            },
        });
    }
    /**
     * Retry Card Payment
     * Queue one more card-charge attempt for an order whose last charge failed. <br>Required Permission: 'create_order'<br>Required Company Permission: 'allow_subscription_card_payment'
     * @returns OrderSchema OK
     * @throws ApiError
     */
    public static ordersRetryCardPaymentPost({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<OrderSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/orders/{order_id}/retry-card-payment/',
            path: {
                'order_id': orderId,
            },
        });
    }
}
